import { Toaster as SonnerToaster, toast } from 'sonner';
import { useTheme } from 'next-themes';

type ToasterProps = React.ComponentProps<typeof SonnerToaster>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { forcedTheme, theme = 'system' } = useTheme();

  return (
    <SonnerToaster
      className="toaster group"
      theme={(forcedTheme ?? theme) as ToasterProps['theme']}
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
          icon: 'mt-0.5 self-start'
        }
      }}
      {...props}
    />
  );
};

export { Toaster, toast };